export const Logo = ({ size = 36 }: { size?: number }) => (
  <div className="flex items-center gap-2.5">
    <div
      className="grid place-items-center rounded-xl bg-gradient-primary font-display font-bold text-primary-foreground shadow-cta"
      style={{ width: size, height: size, fontSize: size * 0.4 }}
      aria-hidden
    >
      Wi
    </div>
    <span className="font-display text-xl font-bold tracking-tight text-foreground">
      Wink<span className="text-primary">ô</span>
    </span>
  </div>
);
